import Web3 from "web3";

const web3 = new Web3(
  window.ethereum ||
    "https://mainnet.infura.io/v3/" + process.env.REACT_APP_INFURA_MACHINIE ||
    "https://rinkeby.infura.io/v3/" + process.env.REACT_APP_INFURA_MACHINIE
);

export default web3;
